import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
import "dayjs/locale/th";
import moment from "moment";
import Autocomplete from "@mui/material/Autocomplete";
import { useState } from "react";

export const TextInput = ({
  label,
  variant,
  maxLength,
  onChange,
  onKeyDown,
  onKeyUp,
  type,
  id,
  name,
  helperText,
  error,
  defaultValue,
  required,
  disabled,
  width,
  value,
  height,
  placeholder,
  endAdornment,
  onFocus,
  startAdornment,
  ref,
  onClick,
  inputRef,
  inputProps,
  autoFocus
}) => {

  return (
    <>
      <Box
        sx={{
          "& > :not(style)": {m: 1,width: width ? width : "25ch"},
        }}
      >
        <TextField
          autoFocus={autoFocus}
          autoComplete='off'
          inputRef={inputRef}
          inputProps={inputProps}
          error={error}
          placeholder={placeholder}
          required={required}
          helperText={helperText}
          defaultValue={defaultValue}
          disabled={disabled}
          ref={ref}
          id={id}
          value={value}
          name={name}
          label={label}
          variant={variant}
          maxLength={maxLength}
          onFocus={onFocus}
          onClick={onClick}
          onChange={(e) => {
            if (maxLength) {
              if (e.target.value.length <= maxLength) {
                onChange(e);
              } else {
                e.target.value = e.target.value.slice(0, maxLength);
              }
            }
            if (type === "number") {
              if (e.target.value.match(/^([0-9])+$/i)) {
                onChange(e);
              }
            } else {
              onChange(e);
            }
          }}
          onKeyDown={(e) => {
            if (type === "number") {
              if (
                (parseInt(e.key) >= 0 && parseInt(e.key) <= 9) ||
                e.key === "Backspace" || e.key === "ArrowLeft" || e.key === "ArrowRight"
              ) {
                if(e.key === "Backspace" && e.target.value.length === 1){
                  e.target.value = "";
                }
              } else {
                e.preventDefault();
              }
            }
            onKeyDown(e);
          }}
          onKeyUp={onKeyUp}
          type={type}
          InputProps={{ sx: { height: height ? height : 35, fontFamily: 'Sarabun'},
            endAdornment:endAdornment,
            startAdornment:startAdornment
          }}
          
        />
      </Box>
    </>
  );
};

export const InputSelect = ({
  value,
  label,
  onChange,
  option,
  id,
  name,
  error,
  helperText,
  onKeyDown,
  ref
}) => {
  return (
    <>
      <Box sx={{ minWidth: 120 }}>
        <FormControl fullWidth>
          <InputLabel>{label}</InputLabel>
          <Select
            ref={ref}
            error={error}
            helperText={helperText}
            id={id}
            value={value}
            label={label}
            name={name}
            onChange={onChange}
            onKeyDown={onKeyDown}
          >
            {option.map((item) => {
              return <MenuItem value={item.value}>{item.label}</MenuItem>;
            })}
          </Select>
        </FormControl>
      </Box>
    </>
  );
};

export const SelectDate = ({ value, onChange, minDate, disabled, views, error, helperText}) => {
  dayjs.locale("th");
  dayjs.extend(buddhistEra);
  const dateformats = {
    monthAndYear: "MMMM",
    keyboardDate: "DD/MM/BBBB",
  };
  return (
    <>
      <LocalizationProvider
        // dateFormats={dateformats}
        dateAdapter={AdapterDayjs}
        adapterLocale="th"
      >
        <Box
          sx={{ "& > :not(style)": { m: 1, width: "100%", height: "50px" } }}
          noValidateautoComplete="off"
        >
          <DatePicker
            views={views}
            minDate={minDate}
            disabled={disabled}
            value={value}
            dateFormat="dd/MM/yyyy"
            onChange={onChange}
            renderInput={(params) => <TextField {...params} 
                                                sx={{ "& > :not(style)": {width: "100%", height: "50px" }}}
                                                // error={error}
                                                // helperText={helperText}
                                    />}
          />
        </Box>
      </LocalizationProvider>
    </>
  );
};

export default function SelectAutoComplete({
  options,
  onChange,
  style,
  value,
  onInputChange,
  label,
  width,
  error,
  name,
  id,
  onKeyDown,
  ref,
  inputRef,
  inputProps
}) {

  return (
    <>
     <Box
        sx={{
          "& > :not(style)": { m: 1, width: width ? width : "25ch",},
        }}
      >
      <Autocomplete
        inputRef={inputRef}
        inputProps={inputProps}
        ref={ref}    
        onChange={(event, newValue) => {
          options.map((item, index) => {
            if (item.label === newValue) {
              onChange(item.value, newValue, item.other_value);
            }
          });
        }}
        onInputChange={(event, newInputValue) =>
          onInputChange(event, newInputValue)
        }
        onKeyDown={onKeyDown}
        value={value}
        name={name}
        id={id}
        noOptionsText="ไม่พบข้อมูล"
        options={options.map((option)=>option.label)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            error={error}
            size="small"
            // InputLabelProps={{style: {fontFamily: 'Kanit'}}}
          />
        )}
        style={style}
      />
    </Box>
    </>
  );
}
